/**
 * LockedPersonaChip — a compact, read-only chip showing the persona bound to a
 * Keystone conversation (U8 decision #3 reload chip).
 *
 * Unlike Edit-with-AI's `LockedPersonaRibbon`, this has no "switch (new chat)"
 * affordance and needs only the persona NAME — which is all the conversation's
 * `personaName` carries after a reload (the full `PersonaListItem` is
 * session-local and gone after refresh). Styling matches the ribbon's locked
 * pill so the two surfaces read consistently. Uses semantic-token-aligned
 * nightshade/ube tokens (same palette as the ribbon).
 */

import type { FC } from 'react';

export interface LockedPersonaChipProps {
  personaName: string;
  /** Optional icon (from the picked persona). Falls back to the wand glyph. */
  icon?: string | null;
}

export const LockedPersonaChip: FC<LockedPersonaChipProps> = ({
  personaName,
  icon,
}) => {
  return (
    <div className="flex items-center gap-2 px-4 py-2.5 border-b border-nightshade-200 dark:border-nightshade-700 bg-nightshade-50 dark:bg-nightshade-800">
      <span className="w-5 h-5 flex items-center justify-center bg-ube-100 dark:bg-ube-900/40 rounded text-[11px]">
        {icon ?? '🪄'}
      </span>
      <span className="text-xs font-medium text-nightshade-800 dark:text-nightshade-100">
        {personaName}
      </span>
      <span className="text-[10px] px-1.5 py-0.5 bg-white dark:bg-nightshade-900 text-nightshade-500 dark:text-nightshade-400 rounded border border-nightshade-200 dark:border-nightshade-700">
        🔒 locked this chat
      </span>
    </div>
  );
};
